import constants from "../utils/constants";
import { privateRequest } from "../utils/axsiosInstances";

class UserMessageController {
  static getMessages(data) {
    return privateRequest({
      method: "get",
      url: constants.messaging.userMessageController,
      params: {
        page: data.page,
        size: data.size || 20,
      },
    });
  }

  static readMessage(data) {
    return privateRequest({
      method: "patch",
      url: constants.messaging.userMessageController + data.id.toString(),
      params: {
        state: data.state,
      },
    });
  }
}

export default UserMessageController;
